import { render, staticRenderFns } from "./FileUploadDetail.vue?vue&type=template&id=f8f998ee&scoped=true&"
import script from "./FileUploadDetail.vue?vue&type=script&lang=js&"
export * from "./FileUploadDetail.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadDetail.vue?vue&type=style&index=0&id=f8f998ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f998ee",
  null
  
)

export default component.exports